import React, { useEffect, useState } from 'react';
import tw from 'twin.macro';
import { PlusIcon, MinusIcon } from 'icons';
import { KudoActionButton } from './';
import { Small } from '../text';
import { notifyError } from '../notifications';

export const KudoUpActionButton = (props) => <KudoActionButton {...props} />;
export const KudoDownActionButton = (props) => <KudoActionButton {...props} />;

export const KudosStyle = ({ ...props }) => {
  const { numKudos, hideActions, hideLabel, large, leftAlign } = props;
  return (
    <div
      css={[
        tw`flex flex-col justify-center items-center font-bold `,
        !hideActions && tw`min-w-[40px] px-2`,
        large && tw`px-4`,
        leftAlign && tw`items-start px-0`,
      ]}
    >
      <span
        css={[
          large && tw`text-xl`,
          numKudos < 0 && tw`text-danger`,
          numKudos > 0 && tw`text-success`,
        ]}
      >
        {numKudos > 0 ? '+' : ''}
        {numKudos}
      </span>
      {!hideLabel && <Small text='kudos' tw='-mt-2.5 !text-[10px]' />}
    </div>
  );
};

export const KudoAmount = ({ ...props }) => <KudosStyle {...props} />;

const kudoActionInitialState = { given: false, direction: '' };

export const Kudos = ({ numOfKudos, hideActions = false, large = false, clickDown, clickUp }) => {
  const [numKudos, setNumKudos] = useState(Number(numOfKudos));
  const [kudoAction, setKudoAction] = useState(kudoActionInitialState);
  const [animation, setAnimation] = useState(false);

  useEffect(() => {
    setAnimation(false);
    setNumKudos(Number(numOfKudos));
    setKudoAction(kudoActionInitialState);
  }, [numOfKudos, clickDown, clickUp]);

  useEffect(() => {
    if (animation) {
      setTimeout(() => {
        setAnimation(false);
      }, 250);
    }
  }, [animation]);

  const onClickHandler = (direction) => {
    if (!kudoAction.given) {
      let updatedKudos = numKudos;
      if (direction === 'up') {
        updatedKudos += 1;
      } else if (direction === 'down') {
        updatedKudos -= 1;
      }
      setNumKudos(updatedKudos);
      setAnimation(true);
      setKudoAction({ given: true, direction });
    } else if (
      (kudoAction.direction === 'up' && direction === 'down') ||
      (kudoAction.direction === 'down' && direction === 'up')
    ) {
      const updatedKudos = direction === 'up' ? numKudos + 2 : numKudos - 2;
      setNumKudos(updatedKudos);
      setAnimation(true);
      setKudoAction({ given: true, direction });
    }
  };

  return (
    <div css={[!hideActions && tw`flex justify-center items-center`]}>
      {!hideActions && (
        <KudoUpActionButton
          direction='up'
          animation={animation}
          kudoAction={kudoAction}
          IconType={PlusIcon}
          color='success'
          onClick={() =>
            clickUp()
              .then(() => {
                onClickHandler('up');
              })
              .catch((error) => {
                notifyError(error);
              })
          }
        />
      )}
      <KudoAmount numKudos={numKudos} hideActions={hideActions} large={large} />
      {!hideActions && (
        <KudoDownActionButton
          direction='down'
          animation={animation}
          kudoAction={kudoAction}
          IconType={MinusIcon}
          color='danger'
          onClick={() =>
            clickDown()
              .then(() => {
                onClickHandler('down');
              })
              .catch((error) => {
                notifyError(error);
              })
          }
        />
      )}
    </div>
  );
};
